import React from 'react'
import styled from 'styled-components'
import { Button } from '@medeo/components'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

const Footer = styled.footer`
  display: flex;
  justify-content: space-between;
`

const ButtonLink = Button.withComponent(Link)

const FormFooter = ({ previous }) => (
  <Footer>
    <FormattedMessage id="previous">
      {label => (
        <ButtonLink variant="outline" to={previous}>
          {label}
        </ButtonLink>
      )}
    </FormattedMessage>
    <FormattedMessage id="next">
      {label => <Button color="primary">{label}</Button>}
    </FormattedMessage>
  </Footer>
)

export default FormFooter



// WEBPACK FOOTER //
// ./src/Patients/components/AddPatientFormFooter.js